import { Pipe, PipeTransform } from '@angular/core';
import { sortBy } from 'lodash';


export class F8SortByPipe implements PipeTransform {
  transform(value: string, key: string) {
    return sortBy(value, key);
  }
static decorators: DecoratorInvocation[] = [
{ type: Pipe, args: [{ name: 'f8SortBy' }, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
